

















import { Vue, Component, Prop } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import EditIcon from "@/basics/icon/EditIcon.vue";
import EditTextModal from "@/components/modal/EditTextModal.vue";

export type SaveEventHandler = (
  handler: (value: string) => Promise<void>
) => void;

@Component({
  components: { 
    CButton,
    EditIcon,
    EditTextModal
     }
})
export default class ActivityViewer extends Vue {
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String, required: true }) value!: string;
  @Prop({ type: String, required: false, default: "" }) info!: string;

  // 操作権限
  @Prop({ type: Boolean, required: true, default: true }) scope!: boolean;

  showModal = false;
  status: "default" | "saving" | "saved" | "error" = "default";

  close(){
    this.showModal = false;
    this.status = "default"; 
  }

  async save(value: string) {
    if (this.status === "saving") {
      return;
    }

    this.status = "saving";

    this.$emit("save", async (handler: any) => {
      try {
        await handler(value);
        this.status = "saved";
      } catch (e) {
        // 編集更新エラー通知
        alert(e.message);
        this.status = "error";
      }
    });
  }
}
